<template>
  <div class="welcome-modal-overlay" v-if="show">
    <div class="welcome-modal-container">
      <div class="welcome-modal-card">
        <div class="welcome-video-container">
          <iframe 
            width="100%" 
            height="100%" 
            :src="welcomeVideoSrc" 
            title="GStocky Complete Tour" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen
          ></iframe>
        </div>
        <div class="welcome-content">
          <h2 class="welcome-title">{{ $t('welcome_to_gstocky') }}</h2>
          <p class="welcome-text" v-html="$t('welcome_description')"></p>
          
          <div class="welcome-actions">
            <button class="btn btn-primary" @click="$emit('skip')">
              {{ $t('skip') }}
            </button>
            <button class="btn btn-success" @click="$emit('skip')">
              {{ $t('get_started') }}
              <AppIcon name="bi-arrow-right" class="bi bi-arrow-right ms-2" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    welcomeVideoSrc() {
      const welcomeVideoId = ['fr', 'ar'].includes(this.$i18n.locale)
        ? '5PC87xnEIJw'
        : 'wRwddJhLHhQ'

      return `https://www.youtube.com/embed/${welcomeVideoId}?autoplay=1&rel=0`
    }
  }
}
</script>

<style scoped>
.welcome-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.welcome-modal-container {
  max-width: 750px;
  width: 100%;
  animation: modalAppear 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.welcome-modal-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
}

.welcome-video-container {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.welcome-content {
  padding: 40px;
  text-align: center;
}

.welcome-title {
  font-size: 2rem;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #1f2937 0%, #4b5563 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.welcome-text {
  font-size: 1.1rem;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 32px;
}

:deep(.highlight) {
  color: #6366f1;
  font-weight: 700;
  background: rgba(99, 102, 241, 0.1);
  padding: 2px 8px;
  border-radius: 6px;
  white-space: nowrap;
}

.welcome-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.btn-skip {
  padding: 12px 24px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: white;
  color: #6b7280;
  font-weight: 600;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-skip:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
}

.btn-start {
  padding: 12px 32px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);
  color: white;
  font-weight: 600;
  box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.3);
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.btn-start:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 25px -5px rgba(99, 102, 241, 0.4);
  filter: brightness(1.1);
}

.btn-start:active {
  transform: translateY(0);
}

@media (max-width: 640px) {
  .welcome-actions {
    flex-direction: column-reverse;
  }
  
  .btn-skip, .btn-start {
    width: 100%;
    justify-content: center;
  }
  
  .welcome-content {
    padding: 30px 20px;
  }
  
  .welcome-title {
    font-size: 1.5rem;
  }
}
</style>
